import React, { useMemo } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowUpRight } from 'lucide-react';
import './ServicesSectionMobile.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getServicesData } from '../data/servicesData';

const ServicesSectionMobile = () => {
  const { t } = useTranslation();
  const services = useMemo(() => getServicesData(t), [t]);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
    adaptiveHeight: true
  };

  return (
    <section className="services-section-mobile section-padding" aria-label="Services">
      <div className="services-mobile-container">
        <header className="services-mobile-header fade-up">
          <span className="services-mobile-label">{t('services_section_header_label')}</span>
          <h2>{t('services_section_header_title')}</h2>
        </header>

        <Slider {...sliderSettings} className="services-mobile-slider">
          {services.map((service) => (
            <div key={service.id} className="services-mobile-slide">
              <article className="service-card-mobile">
                <Link to={`/services/${service.slug}`} className="service-mobile-image" aria-label={service.title}>
                  <img src={service.image} alt={service.title} loading="lazy" />
                </Link>
                <div className="service-mobile-body">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <Link to={`/services/${service.slug}`} className="service-mobile-link">
                    {t('service_card_view_details')} <ArrowUpRight size={14} />
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default ServicesSectionMobile;
